module.exports = __webpack_public_path__ + "static/media/logoVeloe.236076e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/logoVeloe.png
// module id = 397
// module chunks = 0